import { IconName } from '@billy/design-system'
import { ReactElement } from 'react'

import {
  BankingConnectionSuccess,
  BankTransactionsMissing,
  BankTransactionsWallet,
} from '../../../../../../../../../assets/images'
import { BankTransactionsEmptyStateVariant } from '../enums/bankTransactionsEmptyStateVariant'

interface BankTransactionsEmptyStateConfig {
  illustration: ReactElement
  titleKey: string
  descriptionKey: string
  buttonTextKey?: string
  buttonIcon?: IconName
  showCTA?: boolean
}

export const bankTransactionsEmptyStateConfig: Record<
  BankTransactionsEmptyStateVariant,
  BankTransactionsEmptyStateConfig
> = {
  [BankTransactionsEmptyStateVariant.General]: {
    illustration: <BankTransactionsWallet />,
    titleKey: 'empty_state.bank_transactions.title',
    descriptionKey: 'empty_state.bank_transactions.description',
    buttonTextKey: 'empty_state.bank_transactions.buttonText',
    buttonIcon: 'bank',
    showCTA: true,
  },
  [BankTransactionsEmptyStateVariant.ToReview]: {
    illustration: <BankingConnectionSuccess />,
    titleKey: 'empty_state.bank_transactions.to_review.title',
    descriptionKey: 'empty_state.bank_transactions.description',
  },
  [BankTransactionsEmptyStateVariant.Reviewed]: {
    illustration: <BankTransactionsMissing />,
    titleKey: 'empty_state.bank_transactions.reviewed.title',
    descriptionKey: 'empty_state.bank_transactions.reviewed.description',
  },
  [BankTransactionsEmptyStateVariant.NoFilterResults]: {
    illustration: <BankTransactionsMissing />,
    titleKey: 'empty_state.bank_transactions.no_filter_results.title',
    descriptionKey: 'empty_state.bank_transactions.no_filter_results.description',
  },
}
